/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EquipmentFitmentSpecification } from './EquipmentFitmentSpecification';
import {
    EquipmentFitmentSpecificationFromJSON,
    EquipmentFitmentSpecificationFromJSONTyped,
    EquipmentFitmentSpecificationToJSON,
    EquipmentFitmentSpecificationToJSONTyped,
} from './EquipmentFitmentSpecification';

/**
 * 
 * @export
 * @interface SyncGetChangeOutRequest
 */
export interface SyncGetChangeOutRequest {
    /**
     * 
     * @type {string}
     * @memberof SyncGetChangeOutRequest
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof SyncGetChangeOutRequest
     */
    bucketEquipmentExternalId?: string;
    /**
     * 
     * @type {number}
     * @memberof SyncGetChangeOutRequest
     */
    positionNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof SyncGetChangeOutRequest
     */
    changeOutDate?: string;
    /**
     * 
     * @type {number}
     * @memberof SyncGetChangeOutRequest
     */
    partsChanged?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SyncGetChangeOutRequest
     */
    pinsChanged?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SyncGetChangeOutRequest
     */
    basesChanged?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SyncGetChangeOutRequest
     */
    wornCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SyncGetChangeOutRequest
     */
    damagedCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SyncGetChangeOutRequest
     */
    missingCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SyncGetChangeOutRequest
     */
    newPartId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SyncGetChangeOutRequest
     */
    isNewSpec?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof SyncGetChangeOutRequest
     */
    partHoursAtChange?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SyncGetChangeOutRequest
     */
    notes?: string;
    /**
     * 
     * @type {Date}
     * @memberof SyncGetChangeOutRequest
     */
    effectiveAt?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncGetChangeOutRequest
     */
    removedFitmentExternalIds?: Array<string>;
    /**
     * 
     * @type {Array<EquipmentFitmentSpecification>}
     * @memberof SyncGetChangeOutRequest
     */
    installedFitments?: Array<EquipmentFitmentSpecification>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncGetChangeOutRequest
     */
    afterOperations?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncGetChangeOutRequest
     */
    beforeOperations?: Array<string>;
}

/**
 * Check if a given object implements the SyncGetChangeOutRequest interface.
 */
export function instanceOfSyncGetChangeOutRequest(value: object): value is SyncGetChangeOutRequest {
    return true;
}

export function SyncGetChangeOutRequestFromJSON(json: any): SyncGetChangeOutRequest {
    return SyncGetChangeOutRequestFromJSONTyped(json, false);
}

export function SyncGetChangeOutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncGetChangeOutRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'bucketEquipmentExternalId': json['bucketEquipmentExternalId'] == null ? undefined : json['bucketEquipmentExternalId'],
        'positionNumber': json['positionNumber'] == null ? undefined : json['positionNumber'],
        'changeOutDate': json['changeOutDate'] == null ? undefined : json['changeOutDate'],
        'partsChanged': json['partsChanged'] == null ? undefined : json['partsChanged'],
        'pinsChanged': json['pinsChanged'] == null ? undefined : json['pinsChanged'],
        'basesChanged': json['basesChanged'] == null ? undefined : json['basesChanged'],
        'wornCount': json['wornCount'] == null ? undefined : json['wornCount'],
        'damagedCount': json['damagedCount'] == null ? undefined : json['damagedCount'],
        'missingCount': json['missingCount'] == null ? undefined : json['missingCount'],
        'newPartId': json['newPartId'] == null ? undefined : json['newPartId'],
        'isNewSpec': json['isNewSpec'] == null ? undefined : json['isNewSpec'],
        'partHoursAtChange': json['partHoursAtChange'] == null ? undefined : json['partHoursAtChange'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'effectiveAt': json['effectiveAt'] == null ? undefined : (new Date(json['effectiveAt'])),
        'removedFitmentExternalIds': json['removedFitmentExternalIds'] == null ? undefined : json['removedFitmentExternalIds'],
        'installedFitments': json['installedFitments'] == null ? undefined : ((json['installedFitments'] as Array<any>).map(EquipmentFitmentSpecificationFromJSON)),
        'afterOperations': json['afterOperations'] == null ? undefined : json['afterOperations'],
        'beforeOperations': json['beforeOperations'] == null ? undefined : json['beforeOperations'],
    };
}

export function SyncGetChangeOutRequestToJSON(json: any): SyncGetChangeOutRequest {
    return SyncGetChangeOutRequestToJSONTyped(json, false);
}

export function SyncGetChangeOutRequestToJSONTyped(value?: SyncGetChangeOutRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalId': value['externalId'],
        'bucketEquipmentExternalId': value['bucketEquipmentExternalId'],
        'positionNumber': value['positionNumber'],
        'changeOutDate': value['changeOutDate'],
        'partsChanged': value['partsChanged'],
        'pinsChanged': value['pinsChanged'],
        'basesChanged': value['basesChanged'],
        'wornCount': value['wornCount'],
        'damagedCount': value['damagedCount'],
        'missingCount': value['missingCount'],
        'newPartId': value['newPartId'],
        'isNewSpec': value['isNewSpec'],
        'partHoursAtChange': value['partHoursAtChange'],
        'notes': value['notes'],
        'effectiveAt': value['effectiveAt'] === null ? null : ((value['effectiveAt'] as any)?.toISOString()),
        'removedFitmentExternalIds': value['removedFitmentExternalIds'],
        'installedFitments': value['installedFitments'] == null ? undefined : ((value['installedFitments'] as Array<any>).map(EquipmentFitmentSpecificationToJSON)),
        'afterOperations': value['afterOperations'],
        'beforeOperations': value['beforeOperations'],
    };
}

